module.exports = __webpack_public_path__ + "images/img-1D1tk1l.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/80.jpg
// module id = 2015
// module chunks = 0